import { isArray, isObject, kebabCase, transform } from 'es-toolkit/compat';

export const kebabCaseKeys = (obj: object): unknown => {
  if (isArray(obj)) {
    return obj.map((item) => (isObject(item) ? kebabCaseKeys(item) : item));
  }
  if (!isObject(obj)) {
    return obj;
  }
  return transform(
    obj,
    (acc, value, key) => {
      const kebabKey = kebabCase(key as string);
      acc[kebabKey] = isObject(value) ? kebabCaseKeys(value) : value;
    },
    {} as Record<string, unknown>,
  );
};
